// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topup-balance-container-s0mUX {
  padding: 0 32px 20px;
}

.topup-balance-toolbar-cS73T {
  height: 52px;
  align-items: center;
}

.topup-balance-title_title-wM2OF {
  font-size: var(--text-lg);
}

.topup-balance-content-rKPgB {
  display: grid;
  gap: 24px;
  overflow: auto;
  margin-top: 0;
}

.topup-balance-column-rAX2U {
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
}

.topup-balance-outlineCard-U4zYK {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
}

/* Headers */
.topup-balance-sectionHeader-_H_o_ {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.topup-balance-sectionHeaderWithIcon-cD1HX {
  display: flex;
  gap: 16px;
  margin-bottom: 8px;
}

.topup-balance-headerIcon-wk2Ok {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: var(--radius-xl);
  background-color: var(--color-blue-50);
  color: var(--color-blue-500);
  font-size: var(--text-2xl);
  cursor: default;
  flex-shrink: 0;
}

.topup-balance-sectionTitle-RdMJL {
  color: var(--color-neutral-700);
  font-size: var(--text-base);
  font-weight: var(--font-weight-semibold);
  letter-spacing: var(--tracking-tight);
}

.topup-balance-sectionSubtitle-2pNHB {
  max-width: 700px;
  color: var(--color-neutral-500);
  font-size: var(--text-sm);
  line-height: var(--leading-normal);
}

/* ID Section */
.topup-balance-idCard-IdcQ9 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border: 1px solid var(--color-gray-100);
  border-radius: var(--radius-xl);
  background-color: var(--color-gray-50);
}

.topup-balance-idInfo-TL4vR {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.topup-balance-idLabel-d0DnH {
  color: var(--color-neutral-600);
  font-size: var(--text-xs);
  font-weight: var(--font-weight-semibold);
  letter-spacing: var(--tracking-wider);
}

.topup-balance-idValue-DFTKh {
  color: var(--color-gray-800);
  font-size: var(--text-3xl);
  font-weight: var(--font-weight-bold);
}

/* Steps Section */
.topup-balance-stepsList-_JHh5 {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.topup-balance-stepItem-TY_ol {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding-left: 8px;
}

.topup-balance-stepNumber-l5iWa {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  min-width: 26px;
  margin-top: 3px;
  border-radius: 50%;
  background-color: var(--color-blue-50);
  color: var(--color-blue-500);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-semibold);
}

.topup-balance-stepText-YNH3X {
  color: var(--color-neutral-600);
  font-size: var(--text-sm);
  line-height: var(--leading-relaxed);
}

.topup-balance-stepText-YNH3X b {
  color: var(--color-neutral-800);
  font-weight: var(--font-weight-semibold);
}

/* Contact Section */
.topup-balance-contactCard-aGGtC {
  gap: 8px;
}

.topup-balance-contactList-N_Bvu {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.topup-balance-contactItem-vfJ1X {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 0 -12px;
  padding: 12px;
  border-radius: 12px;
  transition: background-color 0.2s ease;
}

.topup-balance-contactItem-vfJ1X:hover {
  background-color: var(--color-neutral-50);
}

.topup-balance-contactIcon-v84cL {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: var(--radius-lg);
  background-color: var(--color-blue-50);
  color: var(--color-blue-500);
  font-size: var(--text-xl);
  transition: transform 0.3s ease, background-color 0.3s ease;
}

.topup-balance-contactItem-vfJ1X:hover .topup-balance-contactIcon-v84cL {
  background-color: var(--color-blue-100);
}

.topup-balance-contactText-XsVLE {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.topup-balance-contactLabel-aVujP {
  color: var(--color-neutral-600);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
}

.topup-balance-contactValue-H6Cbd {
  color: var(--color-blue-500);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
  transition: color 0.2s ease;
}

.topup-balance-contactValue-H6Cbd:hover {
  text-decoration: underline;
}

.topup-balance-bankList-HSANx {
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.topup-balance-bankRow-c86N8 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 12px;
  border-bottom: 1px solid var(--color-neutral-100);
  border-radius: var(--radius-lg);
  transition: background-color 0.2s ease;
}

.topup-balance-bankRow-c86N8:last-child {
  border-bottom: none;
}

.topup-balance-bankRow-c86N8:hover {
  background-color: var(--color-neutral-50);
}

.topup-balance-bankLeft-TE3O0 {
  display: flex;
  align-items: center;
  gap: 16px;
}

.topup-balance-bankLogo-GNYfe {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  object-fit: contain;
}

.topup-balance-bankDetails-hz5wV {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.topup-balance-bankName-Z_eLn {
  color: var(--color-neutral-700);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
}

.topup-balance-bankAccount-dc24D {
  color: var(--color-neutral-700);
  font-size: var(--text-base);
  font-weight: var(--font-weight-semibold);
}

/* Responsive */
@media (min-width: 1024px) {
  .topup-balance-content-rKPgB {
    grid-template-columns: 420px 1fr;
    overflow: hidden;
  }

  .topup-balance-column-rAX2U {
    padding-right: 4px;
    overflow: auto;
  }

  .topup-balance-bankAccountsCard-WzNKr {
    flex: 1;
    overflow: hidden;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/topup-balance/topup-balance.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,sCAAsC;EACtC,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,uCAAuC;EACvC,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,4BAA4B;EAC5B,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA,oBAAoB;AACpB;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,sCAAsC;EACtC,4BAA4B;EAC5B,yBAAyB;EACzB,2DAA2D;AAC7D;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,sCAAsC;EACtC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iDAAiD;EACjD,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,eAAe;AACf;EACE;IACE,gCAAgC;IAChC,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,OAAO;IACP,gBAAgB;EAClB;AACF","sourcesContent":[".container {\n  padding: 0 32px 20px;\n}\n\n.toolbar {\n  height: 52px;\n  align-items: center;\n}\n\n.title_title {\n  font-size: var(--text-lg);\n}\n\n.content {\n  display: grid;\n  gap: 24px;\n  overflow: auto;\n  margin-top: 0;\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  height: 100%;\n}\n\n.outlineCard {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 24px;\n}\n\n/* Headers */\n.sectionHeader {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.sectionHeaderWithIcon {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 8px;\n}\n\n.headerIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: var(--radius-xl);\n  background-color: var(--color-blue-50);\n  color: var(--color-blue-500);\n  font-size: var(--text-2xl);\n  cursor: default;\n  flex-shrink: 0;\n}\n\n.sectionTitle {\n  color: var(--color-neutral-700);\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-semibold);\n  letter-spacing: var(--tracking-tight);\n}\n\n.sectionSubtitle {\n  max-width: 700px;\n  color: var(--color-neutral-500);\n  font-size: var(--text-sm);\n  line-height: var(--leading-normal);\n}\n\n/* ID Section */\n.idCard {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border: 1px solid var(--color-gray-100);\n  border-radius: var(--radius-xl);\n  background-color: var(--color-gray-50);\n}\n\n.idInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.idLabel {\n  color: var(--color-neutral-600);\n  font-size: var(--text-xs);\n  font-weight: var(--font-weight-semibold);\n  letter-spacing: var(--tracking-wider);\n}\n\n.idValue {\n  color: var(--color-gray-800);\n  font-size: var(--text-3xl);\n  font-weight: var(--font-weight-bold);\n}\n\n/* Steps Section */\n.stepsList {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.stepItem {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding-left: 8px;\n}\n\n.stepNumber {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  min-width: 26px;\n  margin-top: 3px;\n  border-radius: 50%;\n  background-color: var(--color-blue-50);\n  color: var(--color-blue-500);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-semibold);\n}\n\n.stepText {\n  color: var(--color-neutral-600);\n  font-size: var(--text-sm);\n  line-height: var(--leading-relaxed);\n}\n\n.stepText b {\n  color: var(--color-neutral-800);\n  font-weight: var(--font-weight-semibold);\n}\n\n/* Contact Section */\n.contactCard {\n  gap: 8px;\n}\n\n.contactList {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.contactItem {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin: 0 -12px;\n  padding: 12px;\n  border-radius: 12px;\n  transition: background-color 0.2s ease;\n}\n\n.contactItem:hover {\n  background-color: var(--color-neutral-50);\n}\n\n.contactIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-lg);\n  background-color: var(--color-blue-50);\n  color: var(--color-blue-500);\n  font-size: var(--text-xl);\n  transition: transform 0.3s ease, background-color 0.3s ease;\n}\n\n.contactItem:hover .contactIcon {\n  background-color: var(--color-blue-100);\n}\n\n.contactText {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.contactLabel {\n  color: var(--color-neutral-600);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n}\n\n.contactValue {\n  color: var(--color-blue-500);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.contactValue:hover {\n  text-decoration: underline;\n}\n\n.bankList {\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n}\n\n.bankRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 12px;\n  border-bottom: 1px solid var(--color-neutral-100);\n  border-radius: var(--radius-lg);\n  transition: background-color 0.2s ease;\n}\n\n.bankRow:last-child {\n  border-bottom: none;\n}\n\n.bankRow:hover {\n  background-color: var(--color-neutral-50);\n}\n\n.bankLeft {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.bankLogo {\n  width: 36px;\n  height: 36px;\n  border-radius: 6px;\n  object-fit: contain;\n}\n\n.bankDetails {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.bankName {\n  color: var(--color-neutral-700);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n}\n\n.bankAccount {\n  color: var(--color-neutral-700);\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-semibold);\n}\n\n/* Responsive */\n@media (min-width: 1024px) {\n  .content {\n    grid-template-columns: 420px 1fr;\n    overflow: hidden;\n  }\n\n  .column {\n    padding-right: 4px;\n    overflow: auto;\n  }\n\n  .bankAccountsCard {\n    flex: 1;\n    overflow: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `topup-balance-container-s0mUX`,
	"toolbar": `topup-balance-toolbar-cS73T`,
	"title_title": `topup-balance-title_title-wM2OF`,
	"content": `topup-balance-content-rKPgB`,
	"column": `topup-balance-column-rAX2U`,
	"outlineCard": `topup-balance-outlineCard-U4zYK`,
	"sectionHeader": `topup-balance-sectionHeader-_H_o_`,
	"sectionHeaderWithIcon": `topup-balance-sectionHeaderWithIcon-cD1HX`,
	"headerIcon": `topup-balance-headerIcon-wk2Ok`,
	"sectionTitle": `topup-balance-sectionTitle-RdMJL`,
	"sectionSubtitle": `topup-balance-sectionSubtitle-2pNHB`,
	"idCard": `topup-balance-idCard-IdcQ9`,
	"idInfo": `topup-balance-idInfo-TL4vR`,
	"idLabel": `topup-balance-idLabel-d0DnH`,
	"idValue": `topup-balance-idValue-DFTKh`,
	"stepsList": `topup-balance-stepsList-_JHh5`,
	"stepItem": `topup-balance-stepItem-TY_ol`,
	"stepNumber": `topup-balance-stepNumber-l5iWa`,
	"stepText": `topup-balance-stepText-YNH3X`,
	"contactCard": `topup-balance-contactCard-aGGtC`,
	"contactList": `topup-balance-contactList-N_Bvu`,
	"contactItem": `topup-balance-contactItem-vfJ1X`,
	"contactIcon": `topup-balance-contactIcon-v84cL`,
	"contactText": `topup-balance-contactText-XsVLE`,
	"contactLabel": `topup-balance-contactLabel-aVujP`,
	"contactValue": `topup-balance-contactValue-H6Cbd`,
	"bankList": `topup-balance-bankList-HSANx`,
	"bankRow": `topup-balance-bankRow-c86N8`,
	"bankLeft": `topup-balance-bankLeft-TE3O0`,
	"bankLogo": `topup-balance-bankLogo-GNYfe`,
	"bankDetails": `topup-balance-bankDetails-hz5wV`,
	"bankName": `topup-balance-bankName-Z_eLn`,
	"bankAccount": `topup-balance-bankAccount-dc24D`,
	"bankAccountsCard": `topup-balance-bankAccountsCard-WzNKr`
};
export default ___CSS_LOADER_EXPORT___;
